import Vue from 'vue'
import Vuex from 'vuex'
import api from 'api'
import user from './modules/user'
import admin from './modules/admin'
import router from 'router'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const state = {
	baseUrl: process.env.API_URL + "/api/sound",
	loginUrl: process.env.API_URL + "/api/login_check",
	refreshUrl: process.env.API_URL + "/api/token/refresh",
	token: localStorage.getItem('token') || "",
	refreshToken: localStorage.getItem('refreshToken') || "",
	headers: {
		'Authorization': 'Bearer ' + localStorage.getItem('token')
	},
	postHeaders: {
		'Content-Type': 'application/x-www-form-urlencoded',
		'Authorization': 'Bearer ' + localStorage.getItem('token')
	},
	jsonHeaders: {
		'Content-Type': 'application/json',
		'Authorization': 'Bearer ' + localStorage.getItem('token')
	},
	postDataHeaders: {
		'Content-Type': 'multipart/form-data',
		'Authorization': 'Bearer ' + localStorage.getItem('token')
	},
	badCredentials: false,
	accessDenied: false,
	alertData: {
		type: 'success',
		text: ''
	},
	showAlert: false,
	cursor: '',
	role: ''
};

const mutations = {
	TOKEN_UPDATED(state, data)	{
		state.badCredentials = false;
		state.accessDenied = false;
		state.token = data.newToken;
		localStorage.setItem('token', data.newToken);
		if (data.newRefreshToken)	{
			state.refreshToken = data.newRefreshToken;
			localStorage.setItem('refreshToken', data.newRefreshToken);
		}
		state.headers['Authorization'] = 'Bearer ' + data.newToken;
		state.postHeaders['Authorization'] = 'Bearer ' + data.newToken;
		state.postDataHeaders['Authorization'] = 'Bearer ' + data.newToken;
		state.jsonHeaders['Authorization'] = 'Bearer ' + data.newToken;
	},
	BAD_CREDENTIALS_UPDATED(state, value)	{
		state.badCredentials = value;
	},
	ACCESS_DENIED_UPDATED(state, value)	{
		state.accessDenied = value;
	},
	ALERT_DATA_UPDATED(state, value)	{
		if (router.history.current.name != 'Connection')	{
			state.alertData = value;
			state.showAlert = true;
		}
	},
	SHOW_ALERT_UPDATED(state, value)	{
		state.showAlert = value;
	},
	CURSOR_UPDATED(state, value)	{
		state.cursor = value;
	},
	CURRENT_USER_ROLE(state, value) {
		state.role = value;
	}
};

const actions = {
	userLogin({state}, {username, password, callbacks})	{
		api.userLogin(state, username, password, callbacks);
	},
	userRefresh({state}, callbacks)	{
		api.userRefresh(state, callbacks);
	},
	userForgotPassword({state}, {username, callbacks})	{
		api.userForgotPassword(state, username, callbacks);
	},
	userChangePassword({state}, {newPassword, resetId, callbacks})	{
		api.userChangePassword(state, newPassword, resetId, callbacks);
	}
};

const store = new Vuex.Store({
    state,
    mutations,
    actions,
    modules: {
        user,
        admin
    },
    strict: debug
});

export default store
